const _raw = '__raw';//Symbol('raw');

class GrassrootCampaign {
    constructor(data) {
        this.id          = parseInt(data.id);
        this.name        = data.name.toString();
        this.description = data.description.toString();

        if(data.image_id !== null) {
            this.image_id = parseInt(data.image_id);
        }
        if(data.image_url !== null) {
            this.image_url = data.image_url.toString();
        }

        this.membercount  = parseInt(data.membercount);
        this.goal         = parseInt(data.goal, 10);
        this.goal_enabled = parseInt(data.goal_enabled, 10);
        this.state        = parseInt(data.state);

        if(data.creator) {
            this.person = data.creator;
        }
        else {
            this.person = false;
        }
        
        this.person_id = parseInt(data.person_id);

        this[_raw] = data;
    }

    hasImage() {
        return !!this.image_url;
    }
}

module.exports = GrassrootCampaign;
